module.exports = __webpack_public_path__ + "assets/img/blank.f4304785.svg";